import { createAction } from 'redux-starter-kit';
import * as api from 'api/user';
import * as Const from 'util/constants';
import { resetSettings as resetSettingsForBundles } from 'actions/bundles';
import { resetSettings as resetSettingsForTemplates } from 'actions/templates';
export const fetchUserInfo = createAction('user/FETCH_USER_STARTED');
export const fetchUserSuccess = createAction('user/FETCH_USER_SUCCESS');
export const fetchUserFailure = createAction('user/FETCH_USER_FAILURE');
export const setBundleType = createAction('user/SET_BUNDLE_TYPE');
export const asyncGetUserInfo = () => dispatch => {
  dispatch(fetchUserInfo());
  api
    .fetchUserInfo()
    .then(userInfo => {
      dispatch(fetchUserSuccess(userInfo));
    })
    .catch(error => dispatch(fetchUserFailure({ error: error.message })));
};

export const fetchPaymentInfo = createAction('user/FETCH_PAYMENT_INFO');
export const fetchPaymentInfoSuccess = createAction('user/FETCH_PAYMENT_INFO_SUCCESS');
export const fetchPaymentInfoFailure = createAction('user/FETCH_PAYMENT_INFO_FAILURE');
export const asyncGetPaymentInfo = () => dispatch => {
  dispatch(fetchPaymentInfo());
  api
    .fetchPaymentInfo()
    .then(paymentInfo => {
      if (paymentInfo.error) {
        dispatch(fetchPaymentInfoFailure({ error: paymentInfo.error }));
      } else {
        dispatch(fetchPaymentInfoSuccess(paymentInfo));
      }
    })
    .catch(error => dispatch(fetchPaymentInfoFailure({ error: error.message })));
};

export const fetchMyPurchases = createAction('user/FETCH_MY_PURCHASES');
export const fetchMyPurchasesSuccess = createAction('user/FETCH_MY_PURCHASES_SUCCESS');
export const fetchMyPurchasesFailure = createAction('user/FETCH_MY_PURCHASES_FAILURE');
export const asyncFetchMyPurchases = type => dispatch => {
  dispatch(fetchMyPurchases());
  api
    .fetchPurchasedBundles(getBundleTypeParam(type))
    .then(purchasedBundles => {
      dispatch(fetchMyPurchasesSuccess(purchasedBundles));
    })
    .catch(error => dispatch(fetchMyPurchasesFailure({ error: error.message })));
};

export const selectBundleType = (type, clearParam = null) => async (dispatch, getState) => {
  dispatch(setBundleType(type));
  if (clearParam) {
    dispatch(resetSettingsForBundles());
    dispatch(resetSettingsForTemplates());
  }
};

const getBundleTypeParam = type => {
  let bundleType = '';
  switch (type) {
    case Const.TYPE_IMAGE_BUNDLES:
      bundleType = 'image';
      break;
    case Const.TYPE_AUDIO_BUNDLES:
      bundleType = 'audio';
      break;
    case Const.TYPE_TEMPLATES:
      bundleType = 'template';
      break;
    default:
      bundleType = 'image';
  }
  return bundleType;
};
